import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { StandardProductDetails } from '@idealsupply/products-api-angular-client';
import { ImageComponent } from 'common-ui';
import { ProductAlternatesSectionComponent } from '../../../../common/alternates/product-alternates-section';
import { ProductBadgesComponent } from '../../../../common/badges/product-badges';
import { ProductIdLabelComponent } from '../../../../common/basic-properties/product-id-label';
import { ProductIsCanadianComponent } from '../../../../common/basic-properties/product-is-canadian';
import { ProductShortDescriptionComponent } from '../../../../common/basic-properties/product-short-description';
import { ProductSectionComplimentaryComponent } from '../../../../common/complimentary/product-section-complimentary';
import { ProductSectionCrossReferencesComponent } from '../../../../common/cross-references/product-section-cross-references';
import { ProductDownloadSpecSheetButtonComponent } from '../../../../common/links/product-download-spec-sheet-button';
import { ProductSectionLinksComponent } from '../../../../common/links/product-section-links';
import { ProductLongDescriptionComponent } from '../../../../common/long-description/product-long-description';
import { ProductSectionSpecificationsComponent } from '../../../../common/specifications/product-section-specifications';
import { ProductVendorLinkComponent } from '../../../../common/vendor/product-vendor-link';
import { ProductVendorPodComponent } from '../../../../common/vendor/product-vendor-pod/product-vendor-pod.component';
import { RenderInProductDetailsViewDirective } from '../../../../layouts/product-detail/product-detail-layout/render-targets/render-in-product-details.directive';
import { ProductDetailLayoutComponentsProviderComponentBase } from '../../../../layouts/product-detail/ProductDetailLayoutComponentsProviderComponentBase';

@Component({
  selector: 'ideal-common-product-detail-components',
  imports: [
    ProductVendorLinkComponent,
    RenderInProductDetailsViewDirective,
    ImageComponent,
    ProductIdLabelComponent,
    ProductShortDescriptionComponent,
    ProductIsCanadianComponent,
    ProductDownloadSpecSheetButtonComponent,
    ProductLongDescriptionComponent,
    ProductSectionCrossReferencesComponent,
    ProductAlternatesSectionComponent,
    ProductSectionComplimentaryComponent,
    ProductSectionLinksComponent,
    ProductSectionSpecificationsComponent,
    ProductBadgesComponent,
    ProductVendorPodComponent,
  ],
  standalone: true,
  templateUrl: './common-product-detail-layout-components-provider.component.html',
  styleUrl: './common-product-detail-layout-components-provider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonProductDetailLayoutComponentsProviderComponent extends ProductDetailLayoutComponentsProviderComponentBase {
  protected readonly productDetails = computed(() => this.productStore.productDetails() as StandardProductDetails | undefined);

  protected readonly specSheetUrl = computed(() => this.productDetails()?.specSheetUrl ?? '');

  protected readonly longDescription = computed(() => this.productDetails()?.longDescription ?? '');
}
